import { EditorState } from '@candulabs/craft';

import { resolvers } from 'craft/resolvers';
import { Resolver } from 'craft/types';

import { deleteNodes } from './deleteNodes';

// Remove any invalid Link Slate nodes (ie: Link Slate nodes with a children without any Text nodes)
export const removeEmptyLinks = (editorState: EditorState) => {
  const linkNodeIds: string[] = Object.values(editorState.nodes)
    .filter((node) => (node.data.type as Resolver) === resolvers.Link)
    .map((node) => node.id);

  // find all child nodes that doesnt have a child
  const nodeIdsToDelete = Object.keys(editorState.nodes).filter(
    (nodeId) =>
      linkNodeIds.includes(editorState.nodes[nodeId].data.parent) &&
      !editorState.nodes[nodeId].data.props?.childrenString?.trim(),
  );

  deleteNodes(
    editorState,
    nodeIdsToDelete.map((n) => [n]),
  );

  return editorState;
};
